export default __webpack_public_path__ + "static/media/ringtone-llamada-saliente.ac7dc581.mp3";